// extracted by mini-css-extract-plugin
export var header = "_sx-1";
export var maskBottom = "_sx-6";
export var maskMiddle = "_sx-7";
export var maskTop = "_sx-5";
export var root = "_sx-0";
export var scrollDownButton = "_sx-3";
export var scrollDownButtonHidden = "_sx-4";
export var viewport = "_sx-2";